import React, { Component } from 'react';
import { Modal } from 'semantic-ui-react';
import { connect } from 'react-redux';

import LocalityCreate_Dwk from '../dwk/name/LocalityCreate';
import ProjectNameComCreate_Dwk from '../dwk/name/ProjectNameComCreate';
import ProjectNameResiCreate_Dwk from '../dwk/name/ProjectNameResiCreate';

import LocalityCreate_Ggn from '../gurgaon/name/LocalityCreate';
import ProjectNameComCreate_Ggn from '../gurgaon/name/ProjectNameComCreate';
import ProjectNameResiCreate_Ggn from '../gurgaon/name/ProjectNameResiCreate';


import { closeModal } from '../../actions/modalAction';

const actions = { closeModal };

class ShowImageModal extends Component {
  render() {
    
    return (
      <Modal 
      className='min-max-width'
      //size="tiny" 
      open={true} 
      onClose={this.props.closeModal}
      closeOnEscape={false}
      closeOnDimmerClick={false}
      basic
      >
       
        <Modal.Content>
        {this.props.locality_Dwk && <LocalityCreate_Dwk closeModal={this.props.closeModal} />}
        {this.props.projCom_Dwk && <ProjectNameComCreate_Dwk closeModal={this.props.closeModal} />}
        {this.props.projResi_Dwk && <ProjectNameResiCreate_Dwk closeModal={this.props.closeModal} />}

        {this.props.locality_Ggn && <LocalityCreate_Ggn closeModal={this.props.closeModal} />}
        {this.props.projCom_Ggn && <ProjectNameComCreate_Ggn closeModal={this.props.closeModal} />}
        {this.props.projResi_Ggn && <ProjectNameResiCreate_Ggn closeModal={this.props.closeModal} />}
        </Modal.Content>
      </Modal>
    );
  }
}

export default connect(
  null,
  actions
)(ShowImageModal);
